import { Delete, Edit } from '@mui/icons-material';
import {
    Button,
    Card,
    CardHeader,
    Collapse,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Stack,
    useMediaQuery,
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import Iconify from 'src/components/iconify';
import CreateGroupModal from 'src/components/modal/CreateGroupModal';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import crypt from 'src/utils/service/crypt';

const ManagerGroupPermission = ({ selectedItem, fuctHandleChange }) => {
    const { t } = useTranslation();
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const params = useSearchParams();

    const [tableDataGroup, setTableDataGroup] = useState([]);
    const [getFlagsGroup, setGetFlagsGroup] = useState(false);
    const getRefGroup = useRef(false);

    const [active, setActive] = useState(null);

    const [visibleCreateGroup, setVisibleCreateGroup] = useState(false);

    const isEdit = useRef(false);
    const data = useRef(null);

    const dataAction = useRef({});
    const [visibleDel, setVisibleDel] = useState(false);
    const delFlags = useRef(false);
    const [deleleFlags, setDeleleFlags] = useState(false);

    const screenPermissions = useRef({});
    const user = useRef({});

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        if (userData) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                user.current = data;
            } catch (error) {}
        }
        const menu = sessionStorage.getItem('menu');
        if (menu) {
            try {
                const data = JSON.parse(crypt.deCode(menu));
                // console.log('Loading menu', data[0]);
                screenPermissions.current = data[0].filter((item) => item.screens_key === 'phan_quyen_nguoi_dung')[0];
                // console.log('screenPermissions', screenPermissions);
            } catch (error) {}
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            getDataGroup();
        }, 600);
    }, []);

    const getDataGroup = useCallback(() => {
        if (getRefGroup.current) {
            return;
        }
        getRefGroup.current = true;
        setGetFlagsGroup(true);
        const Inval = [99999999, ''];
        sendRequest(serviceList.getAllGroup, Inval, getDataResultGroup, true, timeOutFunctGroup, 40000);
    }, []);

    const getDataResultGroup = (reqInfoMap, message) => {
        getRefGroup.current = false;
        setGetFlagsGroup(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log('success: ', message.proc_data.rows, message.proc_data.rowTotal);
            const data = message.proc_data.rows[0].o_1;
            let filteredData = data?.filter((item) => item.user_type !== '1');
            if (user.current?.group_user === '1') {
                filteredData = data;
            } else {
                filteredData = data?.filter((item) => item.user_type !== '1');
            }
            setTableDataGroup(filteredData);
        }
    };

    const timeOutFunctGroup = (reqInfo) => {
        getRefGroup.current = false;
        setGetFlagsGroup(false);
        toast.error(t('error.time_out'));
    };

    const handleDelete = () => {
        if (!dataAction.current?.id) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        setDeleleFlags(true);
        delFlags.current = true;
        const InVal = [dataAction.current?.id];
        // console.log('Delete group: ', InVal);
        sendRequest(serviceList.deleteGroup, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleDel(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleDel(false);
            setTimeout(() => {
                getDataGroup();
            }, 1000);
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    return (
        <>
            <>
                {/* Process */}
                <CreateGroupModal
                    visible={visibleCreateGroup}
                    setVisible={setVisibleCreateGroup}
                    fuctGet={getDataGroup}
                    dataUpdate={data.current}
                    isEdit={isEdit.current}
                />
                {/* Confirm */}
                <ConfirmModal
                    loading={deleleFlags}
                    visible={visibleDel}
                    setVisible={setVisibleDel}
                    handleDelete={handleDelete}
                />

                <Stack
                    display={'flex'}
                    justifyContent={'space-between'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    paddingRight={2}
                    padding={1}
                    paddingLeft={0}
                >
                    <CardHeader
                        title={t('group_permissions')}
                        sx={{ paddingTop: 1, paddingLeft: 2 }}
                        paddingLeft={0}
                        subheader={`${t('total')}: ${tableDataGroup.length}`}
                    />
                    {(screenPermissions.current?.insert_permission === '1' || user.current?.group_user === '1') && (
                        <Button
                            color="primary"
                            startIcon={<Iconify icon="fluent:add-24-filled" />}
                            size="medium"
                            onClick={() => {
                                data.current = null;
                                isEdit.current = false;
                                setVisibleCreateGroup(true);
                            }}
                            variant="contained"
                        >
                            {t('add')}
                        </Button>
                    )}
                </Stack>
                <Divider />
                {!getFlagsGroup && (
                    <List>
                        {tableDataGroup.map((product, index) => {
                            const hasDivider = index < tableDataGroup.length - 1;
                            return (
                                <div key={index}>
                                    <ListItem
                                        divider={hasDivider}
                                        key={product.id}
                                        sx={{ position: '' }}
                                        onClick={() => {
                                            fuctHandleChange(product);
                                        }}
                                        style={{
                                            backgroundColor: selectedItem?.id === product.id ? '#FFFF66' : 'white',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <ListItemText
                                            primary={product.group_nm}
                                            primaryTypographyProps={{ variant: 'subtitle1', color: 'primary' }}
                                            color="primary"
                                            secondary={
                                                product.user_type === '1'
                                                    ? t('Admin')
                                                    : product.user_type === '2'
                                                    ? t('manager')
                                                    : product.user_type === '4'
                                                    ? t('approval')
                                                    : t('staff')
                                            }
                                            secondaryTypographyProps={{ variant: 'body2' }}
                                        />
                                        <IconButton
                                            edge="end"
                                            onClick={() => {
                                                setActive(index === active ? null : index);
                                            }}
                                        >
                                            <Iconify icon="fa-solid:ellipsis-v" />
                                        </IconButton>
                                    </ListItem>

                                    <Collapse in={index === active} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItem sx={{ gap: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                                {(screenPermissions.current?.update_permission === '1' ||
                                                    user.current?.group_user === '1') && (
                                                    <Button
                                                        color="primary"
                                                        startIcon={<Edit fontSize="small" />}
                                                        size="small"
                                                        variant="outlined"
                                                        onClick={() => {
                                                            data.current = product;
                                                            isEdit.current = true;
                                                            setVisibleCreateGroup(true);
                                                        }}
                                                    >
                                                        {t('update')}
                                                    </Button>
                                                )}
                                                {(screenPermissions.current?.delete_permission === '1' ||
                                                    user.current?.group_user === '1') && (
                                                    <Button
                                                        onClick={() => {
                                                            dataAction.current = product;
                                                            setVisibleDel(true);
                                                        }}
                                                        color="error"
                                                        startIcon={<Delete color="error" fontSize="small" />}
                                                        size="small"
                                                        variant="outlined"
                                                    >
                                                        {t('delete')}
                                                    </Button>
                                                )}
                                            </ListItem>
                                        </List>
                                    </Collapse>
                                </div>
                            );
                        })}
                    </List>
                )}
                {tableDataGroup.length === 0 && <Stack>{/* <EmtyData /> */}</Stack>}
                {/* {getFlag && <Loading />} */}
            </>
        </>
    );
};

export default ManagerGroupPermission;
